export const GET_MAP_CONTRACTS = `
  query GetMapContracts($status: String) {
    getMapContracts(status: $status) {
      error {
        code
        message
        statusCode
      }
      data {
        mapId
        mpeId
        mapType
        contractName
        startDate
        endDate
        creditPct
        committedSpend
        eligibleProductCodes
        accountsInScope
        tagValue
        status
        taggedSpendMTD
        taggedSpendYTD
        totalCreditsReceived
        createdDate
        createdBy
        updatedDate
        lastProcessedDate
      }
    }
  }
`
